import React, { useState, useEffect } from 'react'
import {
  Card,
  CardBody,
  Row,
  Col,
  Container,
  Button,
  Form,
  Input,
  FormGroup,
  Label,
  Modal,
  ModalHeader,
  CardHeader,
  CardTitle
} from "reactstrap"
import BootstrapTable from 'react-bootstrap-table-next'
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import paginationFactory from 'react-bootstrap-table2-paginator'
import "react-datetime/css/react-datetime.css";
import DateTime from 'react-datetime'
import ReactSelect from 'components/Form/Select/Select'
import rest from '../../../lib/rest'
import rotas from '../../../services/rotas'
import useToggle from "../../../lib/useToggle"
import Loading from 'lib/loading'
import FormCaixaTotalizado from './FormCaixaTotalizado'
import useForm from "../../../lib/useForm"
import './style.css'
import ModalBody from 'reactstrap/lib/ModalBody'
import moment from 'moment'

const CaixasTotalizados = () => {

  const colunas = [
    {
      dataField: 'id',
      text: 'key',
      align: 'left',
      hidden: true,
    }, {
      dataField: 'quant_caixa',
      text: 'Quant. Caixas',
      align: 'center',
      headerStyle: { cursor: 'default' }
    },
    {
      dataField: 'data',
      text: 'Data',
      align: 'center',
      headerStyle: { cursor: 'default' }
    }
  ]

  const inicialForm = {
    filial: '',
    filialSelect: '',
    caixa: '',
    inicio: '',
    final: '',
    tipo: 'abertura'
  }

  const { SearchBar } = Search
  const [loading, setLoading] = useState(true)
  const [listaCaixa, setListaCaixa] = useState([])
  const [caixa_id, setCaixa_id] = useState('')
  const [filial_id, setFilial_id] = useState('')
  const [periodoModal, setPeriodoModal] = useState('')
  const [modal, setModal] = useToggle(false)
  const [modalFpagtos, setModalFpagtos] = useToggle(false)
  const [listaLoja, setListaLoja] = useState([])
  const [form, onChange, setForm, onChangeSelect, onChangeDate] = useForm(inicialForm)

  // const listaLojas = () => {
  //   let lista = [{ id: 0, title: 'TODAS' }]
  //   const url = rotas.lojas
  //   try {
  //     const retorno = rest.get(url)
  //     retorno.then(ret => {
  //       if (ret.success && ret.success == 'S' && ret.lista != '') {
  //         for (let i = 0; i < ret.lista.length; i++) {
  //           lista[i + 1] = { "id": ret.lista[i].filial_id, "title": ret.lista[i].fantasia }
  //         }
  //         setListaLoja(lista)
  //       }
  //     })
  //     return (true)
  //   } catch (err) {
  //     console.log(err)
  //   }
  // }

  const listarCaixas = () => {
    let lista = []
    const url = rotas.caixaTotalizado;

    const pTipo = form.tipo.substring(0, 1).toUpperCase();

    const retorno = rest.get(url + '?dataI=' + form.inicio + '&dataF=' + form.final + '&tipo=' + pTipo);
    retorno.then(ret => {
      if (ret.success && ret.success == 'S' && ret.lista != '') {
        ret.lista.map((caixa, idx) => {
          caixa.id = idx;
          caixa.data = moment(caixa.data).format('DD/MM/YYYY');
        })
        setListaCaixa(ret.lista)
      }
      setLoading(false)
    })
  }

  useEffect(() => {
    if (loading === true) {
      listarCaixas()
    }
  }, [])

  // useEffect(() => {
  //   if(modal===false){
  //     listaCaixas()
  //   }
  // }, [modal])

  const abreModal = (row) => {
    setPeriodoModal(moment(row.data, 'DD/MM/YYYY').format('YYYY-MM-DD'));
    setModalFpagtos()
  }

  // const pesquisaCaixa = (type, filtros) => {
  //     if(type === 'pagination'){
  //     const pagina = filtros.page
  //     const urlFiltro = rotas.caixa+'?pagina='+pagina
  //     const retorno = rest.get(urlFiltro)

  //     retorno.then(retFiltro => {
  //       setListaCaixa(retFiltro.lista)
  //     })
  //   }
  // }

  // const filtroCaixas = () => {
  //   const urlFiltro = rotas.caixa
  //   if (form !== '') {
  //     return rest.post(urlFiltro, form)
  //       .then(retFiltro => {
  //         let lista = []
  //         // console.log(retFiltro)
  //         if (retFiltro.success == 'S' && retFiltro.lista != '') {
  //           lista = retFiltro.lista
  //           for (let i = 0; i < lista.length; i++) {
  //             lista[i]['id'] = lista[i]['caixa_id'] + '-' + lista[i]['filial_id'] // key da tabela
  //             lista[i]['total_vendas'] = parseFloat(lista[i]['total_vendas']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  //             lista[i]['total_recebimento'] = parseFloat(lista[i]['total_recebimento']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  //             lista[i]['recargas'] = parseFloat(lista[i]['recargas']).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
  //             if (lista[i]['fechamento'] === '') {
  //               lista[i]['fechamento'] = <div className="timeline-heading"><span className="badge badge-success badge-pill m-0 aberto">Aberto</span></div>
  //             }
  //           }

  //           setListaCaixa(lista)
  //         } else {
  //           setListaCaixa([])
  //         }
  //       })
  //   }
  // }

  const handleSubmit = (evt) => {
    evt.preventDefault()
    // console.log(form)
    listarCaixas()
  }


  if (loading) {
    return (
      <Loading
        tipo='paginas'
      />
    )
  } else {
    return (
      <div className="content">
        <Container>
          <Row>
            <Col md="12" className="p-0">
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <CardTitle>CAIXAS</CardTitle>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody>
                  {/* painel do filtro */}
                  <div className="border p-3">
                    <Form onSubmit={handleSubmit}>
                      <Container>
                        <Row>
                          {/* 
                          <Col md='3'>
                            <FormGroup className="mb-0">
                              <ReactSelect
                                name="lojas"
                                placeholder="Selecione a Loja"
                                options={listaLoja}
                                defaultValue={form.filialSelect}
                                onChange={onChangeSelect('filialSelect')}
                                onClick={form.filialSelect ? form.filial = form.filialSelect.id : ''}
                              ></ReactSelect>
                            </FormGroup>
                          </Col> */}

                          {/* <Col>
                            <FormGroup className="mb-0">
                              <Input
                                name="caixa"
                                id="caixa"
                                placeholder="Caixa"
                                value={form.caixa}
                                onChange={onChange('caixa')}
                              ></Input>
                            </FormGroup>
                          </Col> */}

                          <Col>
                            <FormGroup className="mb-0">
                              {/* <DateTime
                                id="dataInicial"
                                name="dataInicial"
                                inputProps={{ placeholder: "Período Inicial" }}
                                closeOnSelect={true}
                                dateFormat="DD/MM/YYYY"
                                timeFormat={false}
                                value={form.inicio}
                                onChange={onChangeDate('dataI')}
                              >
                              </DateTime> */}

                              <DateTime
                                id="dataInicial"
                                name="dataInicial"
                                inputProps={{ placeholder: "Período Inicial" }}
                                closeOnSelect={true}
                                dateFormat="DD/MM/YYYY"
                                timeFormat={false}
                                value={form.inicio}
                                onChange={onChangeDate('inicio')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col>
                            <FormGroup className="mb-0">
                              <DateTime
                                id="dataFinal"
                                name="dataFinal"
                                inputProps={{ placeholder: "Período Final" }}
                                closeOnSelect={true}
                                timeFormat={false}
                                dateFormat="DD/MM/YYYY"
                                value={form.final}
                                onChange={onChangeDate('final')}
                              >
                              </DateTime>
                            </FormGroup>
                          </Col>

                          <Col>
                            <div className="form-check-radio form-check-inline mb-0">
                              <Label className="form-check-label">
                                <Input
                                  type="radio"
                                  name="tipo"
                                  id="tipo1"
                                  value="abertura"
                                  checked={form.tipo === 'abertura' ? true : false}
                                  onChange={onChange('tipo')}
                                />
                                Abertura
                                <span className="form-check-sign"></span>
                              </Label>
                            </div>

                            <div className="form-check-radio form-check-inline mb-0">
                              <Label className="form-check-label">
                                <Input
                                  type="radio"
                                  name="tipo"
                                  id="tipo2"
                                  value="fechamento"
                                  checked={form.tipo === 'fechamento' ? true : false}
                                  onChange={onChange('tipo')}
                                />
                                Fechamento
                                <span className="form-check-sign"></span>
                              </Label>
                            </div>
                          </Col>

                          <Col md="1" className="">
                            <Button
                              className="w-100 m-0"
                              type="submit"
                              color="success"
                              style={{ padding: '6px' }}
                            >
                              <i className="nc-icon nc-zoom-split" style={{ fontSize: '25px' }} />
                            </Button>
                          </Col>

                        </Row>
                      </Container>
                    </Form>
                  </div>

                  <ToolkitProvider
                    search
                    outline
                    keyField="id"
                    data={listaCaixa}
                    columns={colunas}
                  >
                    {

                      props => (
                        <div>

                          <BootstrapTable
                            striped
                            // remote
                            keyField="id"
                            noDataIndication="Nenhum registro encontrado"
                            pagination={paginationFactory({
                              sizePerPage: 10,
                              hideSizePerPage: true,
                              hidePageListOnlyOnePage: true,
                              showTotal: false,
                            })}
                            rowStyle={{ cursor: "pointer" }}
                            rowEvents={{
                              onDoubleClick: (e, row, rowIndex) => {
                                abreModal(row)
                              }
                            }}
                            {...props.baseProps}
                          />

                        </div>
                      )
                    }
                  </ToolkitProvider>
                  {/* <Modal
                    size    = 'xl'
                    isOpen  = {modal}
                  >
                    <ModalHeader>Caixa</ModalHeader>
                    <ModalBody>
                      <FromCaixa
                        fechaModal  = {setModal}
                        caixa_id    = {caixa_id}
                        filial_id   = {filial_id}
                      >
                      </FromCaixa>
                    </ModalBody>
                  </Modal> */}

                  <Modal
                    size='xl'
                    isOpen={modalFpagtos}
                  >
                    <ModalHeader>Caixa</ModalHeader>
                    <ModalBody>
                      <FormCaixaTotalizado
                        fechaModal={setModalFpagtos}
                        periodo={periodoModal}
                        tipo={form.tipo.substring(0, 1).toUpperCase()}
                      >
                      </FormCaixaTotalizado>
                    </ModalBody>
                  </Modal>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    )
  }
}

export default CaixasTotalizados;